import moment from "moment/moment";
import React from "react";
import {fetchDataEntity} from "../../../../api/entity-data";
import {ArrayToSelectOption, FilterArrayByKey} from "../../../../api/fn";
import ControllerSelectBox from "../../../../components/Common/ControllerInput/ControllerSelectBox";
import Title from "../../../../components/Common/Title";
import Page from "../../../../layout/web/Page";
import {Button, Col, DatePicker, Input, Row} from "antd";
import {PostToPbx} from "../../../../api/http-post";
import Connector from "../../../../redux/connector";


const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');

class ContractMinderDatasetServicePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Projects: [],
            Sites: [],
            Clients: [],
            Items: [],

            selectedCompany: "",
            selectedClient: "",
            selectedItem: "yes",
            startDate: startOfMonth,
            endDate: moment().format("YYYY-MM-DD"),
            email: "",
            busy: false,
            hasResult: false,
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Sites", "", "", this, undefined, "common/entity/SettingInvoiceServiceAddonSite/list");
        await fetchDataEntity("Clients", "", "", this, undefined, "common/entity/SettingInvoiceServiceDebtors/list");
        await fetchDataEntity("Items", "", "", this, undefined, "common/entity/SettingInvoiceServiceItem/list");
    }
    handleChangeInput = async (key, value) => {
        this.setState({
            [key]: value,
        })
    }
    handleGetInputValue = (key) => {
        if (typeof this.state[key] === "undefined") {
            return ""
        }
        return this.state[key];
    }
    validation=(value,key)=>{
        if(value==""){
            alert(key+" is required");
            return false;
        }
        return true;
    }
    submitSearch = async () => {
        let state = this.state;

        if(!this.validation(state.selectedCompany,"company")){
            return
        }
        if(!this.validation(state.selectedClient,"client")){
            return
        }
        if(!this.validation(state.selectedItem,"item")){
            return
        }
        if(!this.validation(state.startDate,"start date")){
            return
        }
        if(!this.validation(state.endDate,"end date")){
            return
        }
        if(!this.validation(state.email,"email")){
            return
        }
        let payload = {
            org:this.state.selectedCompany,
            client:state.selectedClient,
            item:state.selectedItem,
            startDate:state.startDate,
            endDate:state.endDate,
            targetSite:"all",
            email:state.email,
            sendEmail:true,
        }
        let endpoint = `/contractminder/dataset/service/without-feedback`
        this.setState({busy: true, hasResult: false})
        console.log("HHHHPayload > ",payload)
        await PostToPbx(payload, endpoint, async (output) => {
            let data = output.RESULT;
            if (typeof data["message"] !== "undefined") {
                this.setState({result:data["message"]})
                this.setState({busy: false, hasResult: true,result:data["message"]})
                return
            }
            this.setState({busy: false, hasResult: true})
            alert("Sorry something went wrong , please retry again!")
        })
    }

    renderCompanyBox = () => {
        let ls = [];
        ls = FilterArrayByKey(this.state.Companies, {})
        ls = ArrayToSelectOption(ls, ["CustomerNumber"], ["Name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Company"}
                name={"selectedCompany"}
            />
        )
    }
    renderClientBox = () => {
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }
            ls.push(row)
        }
        ls = FilterArrayByKey(ls, {})
        ls = ArrayToSelectOption(ls, ["name"], ["name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Client"}
                name={"selectedClient"}
            />
        )
    }
    renderItemBox = () => {
        let ls = [];
        for (let i in this.state.Items) {
            let row = this.state.Items[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }
            if (row.client !== this.state.selectedClient) {
                continue
            }
            ls.push(row)
        }
        ls = FilterArrayByKey(ls, {})
        ls = ArrayToSelectOption(ls, ["name"], ["name"])
        return (
            <ControllerSelectBox
                handleInput2={this.handleChangeInput}
                getHandleValue={this.handleGetInputValue}
                ls={ls}
                label={"Items"}
                name={"selectedItem"}
            />
        )
    }

    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>ContractMinder Dataset Service</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <Row gutter={18}>
                            <Col span={12}>
                                {this.renderCompanyBox()}
                            </Col>
                            <Col span={12}>
                                {this.renderClientBox()}
                            </Col>
                        </Row>
                        <Row gutter={18} style={{marginTop: -30}}>
                            <Col span={12}>
                                {this.renderItemBox()}
                            </Col>
                            <Col span={12} style={styles.dateRow}>
                                <Col span={12} style={{marginTop: 30, height: 40}}>
                                    <DatePicker
                                        style={styles.datePickerBox}
                                        onChange={(date, dateString) => this.setState({startDate: dateString})}
                                        placeholder={"Start Date"}
                                    />
                                </Col>
                                <Col span={12} style={{marginTop: 30, height: 40}}>
                                    <DatePicker
                                        style={styles.datePickerBox}
                                        onChange={(date, dateString) => this.setState({endDate: dateString})}
                                        placeholder={"End Date"}
                                    />
                                </Col>
                            </Col>
                        </Row>
                        <Row gutter={18} style={{marginLeft:5}}>
                            <Col span={12}>
                                <Input
                                    size="small"
                                    onChange={(e) => this.setState({email: e.target.value})}
                                    placeholder={"Enter email address to send report"}
                                    style={{ height: 40}}
                                />
                            </Col>
                            <Col span={12} style={{ height: 40}}>
                                <Button
                                    style={styles.datePickerBox}
                                    onClick={() => this.submitSearch()}
                                >
                                    Search
                                </Button>
                            </Col>
                        </Row>
                        <Row gutter={18} style={{
                            paddingTop: 40,
                        }}>
                            <div style={{
                                borderRadius: 5,
                                borderWidth: 1,
                                borderColor: "lightblue",
                                borderStyle: 'solid',
                                minHeight: 400,
                                minWidth:"100%",
                                padding: 5,
                                backgroundColor:"white"
                            }}>

                                {this.state.hasResult && (
                                    <div style={{}}>
                                        {this.state.result}
                                    </div>
                                )}

                            </div>
                        </Row>

                    </div>
                </div>
            </Page>
        )
    }
}

export default Connector(ContractMinderDatasetServicePage);
const styles = {
    btnExport:{
        fontsize: 11,
        width: 75,
        marginTop:1,
        backgroundColor: "gray",
        color:"white"
    },
    boxFilterInner: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems:"center",
        paddingLeft:10,
        paddingRight:5,
        borderRight:"1px solid black",
        fontsize:14,
        fontWeight:"bold"
    },
    boxFilter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems:"center"
    },
    dateRow: {
        display: "flex",
        flexDirection: "row"
    },
    datePickerBox: {
        height: 40,
        width: "100%"
    },
    row1Th: {
        border: "1px solid black",
    },
    rowForm: {
        marginBottom: 10,
        paddingBottom: 5,
        border: "0px solid lightgray",
        borderBottomWidth: 1,

    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
